// @flow
import { USERLIST_UPDATED } from '../actions/admin.actions';

const initialState = {};

export default (state: Object = initialState, action: { type: String, data: Object }) => {
  switch (action.type) {
    case USERLIST_UPDATED:
      const { data } = action;
      return {
        ...state,
        ...data
      };
    default:
      return {
        ...state
      };
  }
};



// WEBPACK FOOTER //
// ./src/reducers/adminReducer.js